import React, { useState, useEffect } from 'react';

export default function AddressAutocomplete({ value, onChange, onSelect, placeholder }) {
  const [suggestions, setSuggestions] = useState([]);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const timer = setTimeout(async () => {
      if (value && value.length > 2 && show) {
        try {
          const res = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(value)}&limit=5`);
          const data = await res.json(); setSuggestions(data.features || []);
        } catch (err) { }
      } else setSuggestions([]);
    }, 300); return () => clearTimeout(timer);
  }, [value, show]);

  const handlePick = (s) => {
    const label = s.properties.label;
    const [lon, lat] = s.geometry.coordinates;
    onChange(label);
    if (onSelect) onSelect({ label, lat, lon });
    setShow(false);
  };

  return (
    <div style={{ position: 'relative' }}>
      <input 
        autoComplete="off"
        value={value} 
        onChange={(e) => { onChange(e.target.value); setShow(true); }} 
        onFocus={() => setShow(true)}
        placeholder={placeholder} 
        style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1px solid #e2e8f0', background: '#f8fafc', fontWeight: 600, color: '#0f172a', boxSizing: 'border-box' }} 
      />
      {show && suggestions.length > 0 && (
        <div style={{ position: 'absolute', top: '105%', left: 0, right: 0, background: '#fff', border: '1px solid #e2e8f0', zIndex: 12000, borderRadius: 14, boxShadow: '0 8px 24px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
          {suggestions.map((s, i) => (
            <div key={i} onClick={() => handlePick(s)} style={{ padding: '10px 14px', fontSize: 13, cursor: 'pointer', borderBottom: i === suggestions.length - 1 ? 'none' : '1px solid #f1f5f9' }}>
               <div style={{ fontWeight: 800, color: '#0f172a' }}>{s.properties.label}</div>
               <div style={{ fontSize: 10, color: '#94a3b8' }}>{s.properties.postcode} {s.properties.city}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
